const { REACT_APP_API_URL } = process.env;
export const apiURL = REACT_APP_API_URL || "http://localhost:3000";
